import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Circle, Path } from "react-native-svg";

export const IconFullMoon: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconFullMoon"><Circle cx="13.5" cy="7.5" r="1.5" stroke="currentColor"/><Circle cx="7.75" cy="9.75" r="1.25" stroke="currentColor"/><Circle cx="10.5" cy="15.75" r="2" stroke="currentColor"/><Path d="M21 9C19 9 17 10.96 17 12.9998C17 14.7686 18.1481 16.2693 19.7397 16.7972" stroke="currentColor"/><Circle cx="12" cy="12" r="9.5" stroke="currentColor"/></CentralIconBase>;
});

export default IconFullMoon;
